(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["calculadora-envio-pdp"] && !Shopify.designMode) return;
  try {
    (function () {
      // El asset compartido carga con `defer`, puede no estar listo cuando este bloque
      // se ejecuta — se espera a DOMContentLoaded, igual que en snippets/calculadora-envio.liquid.
      function iniciar() {
        if (!window.CalculadoraEnvio) return; // fail-silent si el asset compartido no cargó

        var datos = window.CalculadoraEnvio;
        var money = datos.money;
        var UMBRAL_ENVIO_GRATIS = datos.UMBRAL_ENVIO_GRATIS;
        var COMUNAS = datos.COMUNAS;

        document.querySelectorAll('[data-comuna-envio-pdp]').forEach(function (raiz) {
          if (raiz.dataset.calculadoraEnvioPdpInit) return;
          raiz.dataset.calculadoraEnvioPdpInit = 'true';

          var select = raiz.querySelector('[data-calculadora-envio-pdp-select]');
          var resultado = raiz.querySelector('[data-calculadora-envio-pdp-resultado]');
          var lineaEnvio = raiz.querySelector('[data-calculadora-envio-pdp-linea-envio]');
          var lineaTotal = raiz.querySelector('[data-calculadora-envio-pdp-linea-total]');
          var progreso = raiz.querySelector('[data-envio-gratis-pdp-progreso]');
          var progresoTexto = raiz.querySelector('[data-envio-gratis-pdp-texto]');
          var progresoRelleno = raiz.querySelector('[data-envio-gratis-pdp-relleno]');
          // Precio de la variante en la convención x100 de Shopify — misma conversión usada
          // en snippets/calculadora-envio.liquid para el subtotal del carrito.
          var precioProducto = Number(raiz.dataset.precioProducto || 0) / 100;

          // Regla de negocio (confirmada por Nicolás el 2026-09-25): la barra de envío a $1
          // depende ÚNICA Y EXCLUSIVAMENTE del monto vs. $30.000 — no de la comuna elegida,
          // ni de la tarifa real que devuelva Shopify. Se calcula una sola vez, con el
          // precio de este producto, y no se vuelve a tocar cuando el cliente cambia de
          // comuna en el selector de abajo; son dos señales independientes a propósito.
          function actualizarProgreso() {
            if (precioProducto >= UMBRAL_ENVIO_GRATIS) {
              progresoTexto.textContent = '🎉 Tu envío ya es a $1 en las principales comunas';
              progresoRelleno.style.width = '100%';
            } else {
              var faltante = UMBRAL_ENVIO_GRATIS - precioProducto;
              var porcentaje = Math.max(0, Math.min(100, (precioProducto / UMBRAL_ENVIO_GRATIS) * 100));
              progresoTexto.textContent = 'Agrega ' + money(faltante) + ' en productos y tu envío es a $1 en las principales comunas';
              progresoRelleno.style.width = porcentaje + '%';
            }
            progreso.hidden = false;
          }

          function mostrarConTarifa(precioEnvio, etiqueta, esReal) {
            var esPromo = precioEnvio <= 1;
            resultado.dataset.estado = esPromo ? 'promo' : 'ok';
            lineaEnvio.textContent = 'Envío estimado a ' + etiqueta + (esPromo ? ' (promo activa 🎉)' : '') + ': ' + money(precioEnvio);
            lineaTotal.textContent = 'Total estimado: ' + money(precioProducto + precioEnvio);
            resultado.hidden = false;
          }

          actualizarProgreso();

          select.addEventListener('change', function () {
            var opcion = select.options[select.selectedIndex];
            var clave = select.value;
            if (!clave) {
              resultado.hidden = true;
              return;
            }
            var etiqueta = (COMUNAS[clave] && COMUNAS[clave].etiqueta) || opcion.textContent;

            // Se intenta la tarifa REAL primero (mismo dato que usaría el carrito — funciona
            // si ya hay algo en el carrito, aunque sea de otro producto). Solo si no hay
            // datos reales disponibles (carrito vacío, fetch falló) se cae a la tabla
            // estática de este archivo (data-precio de cada <option>).
            datos.obtenerTarifas().then(function (tarifas) {
              var tarifaReal = tarifas ? datos.encontrarTarifa(tarifas, clave) : null;
              if (tarifaReal) {
                mostrarConTarifa(Number(tarifaReal.price), etiqueta, true);
              } else {
                mostrarConTarifa(Number(opcion.dataset.precio), etiqueta, false);
              }
            });
          });
        });
      }

      // 'interactive' NO es seguro: es el estado en que corren los scripts `defer` (el
      // parser ya terminó pero DOMContentLoaded todavía no se dispara), y en ese momento
      // el asset compartido (que va después en el documento) puede no haber corrido
      // todavía — bug real encontrado en vivo el 2026-09-25: este bloque se ejecutaba en
      // 'interactive' (dentro del bundle de Shopify block-scripts.js), veía
      // `window.CalculadoraEnvio` vacío y se rendía para siempre, sin reintentar. Solo
      // 'complete' garantiza que todo lo demás ya corrió.
      if (document.readyState === 'complete') {
        iniciar();
      } else {
        document.addEventListener('DOMContentLoaded', iniciar);
      }

      // Mismo resguardo que snippets/calculadora-envio.liquid: si el selector de variante
      // llega a re-renderizar esta sección del producto (Shopify puede hacerlo vía Section
      // Rendering), el nuevo marcado quedaría sin engachar. `iniciar()` es seguro de
      // llamar varias veces (init por nodo), así que un MutationObserver lo reintenta.
      if (window.MutationObserver) {
        new MutationObserver(function () {
          iniciar();
        }).observe(document.body, { childList: true, subtree: true });
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
